import React, {memo, useCallback, useEffect, useRef, useState,} from "react";
import {SectorSvg} from "../../../../shared/assets/svgs/SectorSvg";
import {useTranslation} from "react-i18next";
import {Fill, Stroke, Style} from "ol/style";
import {Button, useToast} from "../../../../shared/ui";
import {useSectors} from "../../hooks/useSectors";
import {FeatureLike} from "ol/Feature";
import {colorsHex} from "../../../../shared/constants/consts.common";
import {getMarkerColor} from "../../../../shared/lib/map.fns";

interface Props {
  map: any;
  bound: any;
  zoom: number;
}

type TPolygonCache = {
  [key: string]: Style
};
const MIN_ZOOM_VISIBLE = 14;

export const SectorPolygonButton = memo(({map, bound, zoom}: Props) => {
  const {t} = useTranslation(["shipping"]);
  const [isVisibleSector, setVisibleSector] = useState(false);
  const toast = useToast();
  const polygonCache = useRef<TPolygonCache>({});
  const unusedColorsRef = useRef([...colorsHex]); // copy
  
  useEffect(() => {
    if (isVisibleSector && zoom < MIN_ZOOM_VISIBLE) {
      setVisibleSector(false);
    }
  }, [zoom]);
  
  const sectorStyle = useCallback((feature: FeatureLike) => {
    const code = feature.get("code") || "";
    if (!polygonCache.current[code]) {
      const color = getMarkerColor(unusedColorsRef.current, code, true);
      polygonCache.current[code] = new Style({
        stroke: new Stroke({
          color, width: 2.5,
        }), fill: new Fill({
          color: color + "25",
        })
      })
    }
    return polygonCache.current[code];
  }, []);
  
  useSectors(bound, map, isVisibleSector, sectorStyle);
  
  const handleSectorVisible = () => {
    if (zoom < MIN_ZOOM_VISIBLE) {
      toast.error(t("The Sector layer can be visible when the zoom level exceeds")+MIN_ZOOM_VISIBLE);
      return;
    }
    setVisibleSector((prev) => !prev);
  };
  
  return (<Button
    size={"sm"}
    variant={"primary"}
    className={"button " + (isVisibleSector)}
    onClick={handleSectorVisible}>
    <SectorSvg color={(isVisibleSector) ? "white" : "black"} />
    {t("sector layer")}
  </Button>);
});
